import styles from './index.module.scss'
import GenerateResults from './GenerateResultsPage'
import { GenerateContext } from '../hooks/GenerateContext'
import { useContext, forwardRef } from 'react'
import PlaceholderPage from './PlaceholderPage'

const MiddleComp = forwardRef((props, ref) => {

    const {
        projectId,
        imageType,
        currentInputType,
    } = useContext(GenerateContext)

    return (
        <div className={styles.MiddleComp}>
            {
                projectId ? (
                    <GenerateResults  projectId={projectId} ref={ref}/>
                ) : (
                    <PlaceholderPage imageType={imageType} inputType={currentInputType} />
                )
            }
        </div>
    )
})

export default MiddleComp